module.exports = __webpack_public_path__ + "static/media/ucsb_logo.bb92471f.png";